export default "__VITE_ASSET__BBo1Tx3r__"